/* @flow */

import React from 'react';
import EditoApp from 'edito/App';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const serialize = blocks => {
    onSerialize({
      ...content,
      blocks,
    });
  };

  return (
    <div>
      <EditoApp
        mode="draft"
        blocks={content.blocks || []}
        onUpdate={serialize}
        locked
      />
    </div>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/minimal/Edit.js